import React from "react";

import Accordion from "component/Accordion/Accordion";
// import HearFrom from "./HearFrom";
import Experience from "./Experience";
import Neo from "./Neo";
import Banner from "component/Banner/Banner";
import Blogs from "component/Blogs/Blogs";
import SuperHuman from "container/Home/SuperHuman";
// import Carousel from "component/Carousel/Carousel";
import SeeProducts from "./SeeProducts";
import useScreenMobile from "hooks/useScreenMobile";
import ProductScroll from "component/ProductScroll/ProductScroll";
import StoreInAction from "./StoreInAction";
// import CheckOut from "./CheckOut";
import HearFromTheBest from "./HearFromBest";
// import Images from "./Images";
// import Lasting from "./Lasting";

const Home = ({ targetSectionRef }) => {
  const isMobile = useScreenMobile({ size: 667 });

  return (
    <>
      <Banner />
      {isMobile && <SeeProducts />}
      <Neo />
      <SuperHuman />

      <StoreInAction />
      <ProductScroll />

      {/* <Lasting /> */}
      <Experience />
      {/* <HearFrom /> */}
      <HearFromTheBest />

      {/* <Carousel /> */}
      {/* <CheckOut /> */}
      <Blogs />
      {/* <Images /> */}
      <Accordion />
    </>
  );
};

export default Home;
